import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  label: {
    fontWeight: '800',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 0px',
    color: theme.palette.text.primary,
  },
  container: {
    boxSizing: 'border-box',
  },
}));

export default useStyles;
